const getArtStoreApi = (
  onCartItemsChange,
  cartApi,
  openCart,
  updateItemValidation,
  navigateToHomePage,
) => {
  return {
    initCartForm: () => {},
    subscribeShowCart: () => {},
    refreshCartItems: () => {},
    showCart: () => openCart(),
    clearCart: () => {
      cartApi.clearAll();
      onCartItemsChange();
    },
    addToCart: (data) => {
      cartApi.addToCart(data);
      updateItemValidation(data);
      onCartItemsChange();
      openCart();
    },
    backHome: () => navigateToHomePage(),
    updateCartItem: (data) => {
      cartApi.updateCartItem(data);
      onCartItemsChange();
      openCart();
    },
    removeFromCart: (data) => {
      cartApi.removeCartItem(data);
      onCartItemsChange();
      openCart();
    },
  };
};

export default getArtStoreApi;
